<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">算税记录</li>
    </ul>
    <ul class="c-list-search">
      <el-radio-group v-model="state.params.status" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="0">算税中</el-radio-button>
        <el-radio-button :value="1">已完成</el-radio-button>
        <el-radio-button :value="2">已取消</el-radio-button>
      </el-radio-group>
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="名称、单号、工资表单号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <el-select
        v-model="state.params.d_tax_type_id"
        placeholder="报税类型"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.taxTypeData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <div style="display: flex">
        <el-config-provider
          :value-on-clear="null"
          :empty-values="[undefined, null]"
        >
          <el-select
            v-model="state.params.withholding_agent_type"
            class="c-withholdingagent-search-select"
            @change="
              delete state.withholding_agent_arr;
              state.showWithholdingAgent = false;
            "
          >
            <el-option label="扣缴义务人" :value="0" />
            <el-option label="供应商" :value="1" />
          </el-select>
        </el-config-provider>
        <div
          class="c-withholdingagent-search-groupbox"
          @click="state.showWithholdingAgent = true"
        >
          <li style="flex: 1; display: flex; column-gap: 5px">
            <template v-if="state.withholding_agent_arr?.length > 0">
              <div
                class="c-withholdingagent-search-tag"
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ state.withholding_agent_arr[0]?.name }}
              </div>
              <el-popover
                v-if="state.withholding_agent_arr?.length > 1"
                placement="right"
                width="auto"
                popper-style="max-height: 90vh;overflow-y: auto;"
              >
                <template #reference>
                  <div class="c-withholdingagent-search-tag" @click.stop="">
                    {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                  </div>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      row-gap: 5px;
                      width: fit-content;
                    "
                  >
                    <ul
                      v-for="(item, index) in state.withholding_agent_arr"
                      :key="item"
                      style="
                        white-space: nowrap;
                        background-color: #f0f2f5;
                        color: var(--el-color-info);
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 0 9px;
                        height: 24px;
                        line-height: 24px;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <li>{{ item.name }}</li>
                      <el-icon
                        @click.stop="
                          state.withholding_agent_arr.splice(index, 1)
                        "
                        color="#a2a2a2"
                        style="cursor: pointer"
                        ><CircleClose
                      /></el-icon>
                    </ul>
                  </div>
                </template>
              </el-popover>
            </template>
            <text v-else style="color: #a2a2a2">
              {{
                "点击选择" +
                (state.params.withholding_agent_type === 0
                  ? "扣缴义务人"
                  : "供应商")
              }}
            </text>
          </li>
          <el-icon
            v-if="state.withholding_agent_arr?.length > 0"
            @click.stop="delete state.withholding_agent_arr"
            color="#a2a2a2"
            ><CircleClose
          /></el-icon>
        </div>
      </div>
      <el-date-picker
        v-model="state.params.month"
        type="month"
        placeholder="薪资所属期"
        format="YYYY年M月"
        value-format="YYYY-MM"
      />
      <el-date-picker
        v-model="state.params.tax_month"
        type="month"
        placeholder="税款所属期"
        format="YYYY年M月"
        value-format="YYYY-MM"
      />
      <li style="width: 400px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--发薪日期--"
          end-placeholder="--发薪日期--"
          style="width: 100%"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <el-tree-select
        v-model="state.params.belonger_id"
        :props="{
          value: 'id',
          label: 'name',
          class: 'belonger-tree-class',
        }"
        placeholder="负责人"
        :data="state.admin_data"
        style="width: 200px"
        default-expand-all
        filterable
        clearable
      >
        <template #default="{ data }">
          <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
          <el-icon :size="16" v-else><User /></el-icon>
          <span style="margin-left: 3px">{{ data.name }}</span>
        </template>
      </el-tree-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/单号"
          prop="status"
          sortable="status"
          width="120"
        >
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <div style="display: flex; align-items: center">
                  <c_status arrName="calctax_status" :value="row.status" />
                  <el-popover
                    v-if="row.calc_tax_msg"
                    placement="right"
                    trigger="hover"
                  >
                    <template #reference>
                      <el-icon
                        color="#ffa500"
                        style="margin-left: 5px; cursor: pointer"
                      >
                        <QuestionFilled />
                      </el-icon>
                    </template>
                    <template #default>
                      <text
                        style="
                          font-size: 13px;
                          line-height: 22px;
                          color: #ffa500;
                          letter-spacing: 2px;
                        "
                        :title="row.calc_tax_msg"
                      >
                        {{ row.calc_tax_msg }}
                      </text>
                    </template>
                  </el-popover>
                </div>
              </template>
              <template #bottom>
                <text
                  style="color: #1e90ff"
                  class="text-hover-decoration"
                  :title="row.order_id"
                  @click="$onCopy(row.order_id)"
                >
                  {{ row.order_id }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="名称/所属客户" min-width="260">
          <template #default="{ row }">
            <c_tabgroup :value2="row.customer_name">
              <template #top>
                <div :title="row.name">
                  <span
                    v-if="row.type == 1"
                    style="
                      color: #fff;
                      font-size: 11px;
                      padding: 2px;
                      line-height: 12px;
                      background-color: #1e90ff;
                      border-radius: 2px;
                    "
                    >0申报</span
                  >
                  {{ row.name }}
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="工资表单号" min-width="160">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              :title="row.payroll_order_id"
              @click="$onCopy(row.payroll_order_id)"
            >
              {{ row.payroll_order_id }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :formatter="$tab_TextFormat"
          width="160"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="pay_date"
          label="发薪日期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_ShowToolTip"
          min-width="180"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_num"
          label="算税人数"
          :formatter="$tab_NumberFormat"
          width="80"
          align="center"
        />
        <el-table-column
          prop="done_num"
          label="已算税"
          :formatter="$tab_NumberFormat"
          width="80"
          align="center"
        />
        <el-table-column
          prop="undone_num"
          label="未算税"
          :formatter="$tab_NumberFormat"
          width="80"
          align="center"
        />
        <el-table-column
          prop="abnormal_num"
          label="算税失败"
          :formatter="$tab_NumberFormat"
          width="80"
          align="center"
        />
        <el-table-column label="负责人" width="180">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.belonger_name || '-'"
              :value2="row.belonger_department_name"
            />
          </template>
        </el-table-column>
        <el-table-column label="提交人/时间" width="160" fixed="right">
          <template #default="{ row }">
            <c_tabgroup :value2="row.submit_time">
              <template #top>
                <div>
                  <text>{{ row.add_admin_name || "-" }}</text>
                  <text v-if="row.add_department_name">{{
                    "/" + row.add_department_name
                  }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" fixed="right">
          <template #header>
            <text title="CalcTax">操作</text>
          </template>
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxDetail',
                  title: '算税单-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="
                row.withholding_agent_type === 0 &&
                row.status === 0 &&
                $judge_auth('69')
              "
              :title="row.id"
              >操作
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxDetail',
                  title: '算税单-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              :title="row.id"
              v-else
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="
          state.showWithholdingAgent &&
          state.params.withholding_agent_type === 0
        "
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="
          state.showWithholdingAgent &&
          state.params.withholding_agent_type === 1
        "
        title="选择供应商"
        @close="state.showWithholdingAgent = false"
      >
        <c_SupplierSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_SupplierSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import { calctax_list } from "@/http/calctax";
import { taxtype_select } from "@/http/dictionary";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    data: Object,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      withholding_agent_arr: [],
    });
    onMounted(() => {
      state.params.keywords = props.data?.keywords;

      onLoadTaxType();
      onLoadAdmin();
      onLoadCustomer();
      onLoad();
    });

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    //加载负责人
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      calctax_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onRowClick,
      onLoadAdmin,
    };
  },
};
</script>
<style></style>
